// extracted by mini-css-extract-plugin
module.exports = {"el":"checkbox_el___wUG2","el_in":"checkbox_el_in__MyyES"};